import { useAppActivity } from '../../utils/appActivity'
import { defaultSignedInHomePath } from '../../utils/doggosRoles'
import {
  isProductionStreamChat,
  streamChatEnvironmentLabel,
} from '../../utils/streamEnvironment'
import { useProfileData } from '../AuthProvider'
import * as style from './style.module.scss'
import classNames from 'classnames'
import Link from 'gatsby-link'
import * as React from 'react'

const Logo = ({
  linked = true,
  streamEnvironment = false,
  accountId = null,
}) => {
  const profile = useProfileData({ optional: true })
  const busy = useAppActivity()
  const destination = profile ? defaultSignedInHomePath(profile) : '/'
  const testingWorkspace = accountId === 'reliable-pet-care'
  const streamLabel = streamEnvironment
    ? `${streamChatEnvironmentLabel()}${
        testingWorkspace ? ' · Reliable Pet Care testing workspace' : ''
      }`
    : 'doggos'
  const content = (
    <>
      <span
        aria-label={streamLabel}
        title={streamEnvironment ? streamLabel : undefined}
        className={classNames(
          style.dot,
          streamEnvironment &&
            (testingWorkspace || !isProductionStreamChat()) &&
            style.dotBlueprint,
          busy && style.dotBusy
        )}
      />
      doggos
    </>
  )

  if (!linked) {
    return <span className={style.logo}>{content}</span>
  }

  return (
    <Link to={destination} className={style.logo}>
      {content}
    </Link>
  )
}

export default Logo
